import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { NgxSpinnerModule } from 'ngx-spinner';
import {
  TabsModule,
  FilterModule,
  PaginationModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
} from 'beyond-util';

import { CiljneGrupeComponent } from './ciljne-grupe.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    PaginationModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    NgxSpinnerModule,
  ],
  entryComponents: [CiljneGrupeComponent],
  declarations: [CiljneGrupeComponent],
  exports: [CiljneGrupeComponent],
})
export class CiljneGrupeModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/ciljne-grupe/ciljne-grupe.module.ts